import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map, Observable, of } from "rxjs";
import { IMasterAccountAccessResponse } from './irb-orders.model';
import { AppService } from "@irb/app.service";
import { IUserDetails } from "@irb/app.model";
import { AccountName } from '@irb/irb-clients/irb-clients.model';
import { IOrders } from "@irb/irb-orders/irb-orders.model";

@Injectable({
  providedIn: 'root'
})
export class IrbOrdersService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };

  orderBlotterUrl = '/irebalone';
  ENABLE_ORDERBLOTTER_APIS: boolean;
  ENABLE_PORT_ACC_APIS: boolean;
  ENABLE_MODELSERVICE_APIS: boolean;
  
  constructor(public _http: HttpClient, protected as: AppService) {
    const featureFlags = this.as.getItem('IRB_APP_CONFIG')?.featureFlags;
    this.ENABLE_ORDERBLOTTER_APIS = featureFlags?.ENABLE_ORDERBLOTTER_APIS || false;
    this.ENABLE_PORT_ACC_APIS = featureFlags?.ENABLE_PORT_ACC_APIS || false;
    this.ENABLE_MODELSERVICE_APIS = featureFlags?.ENABLE_MODELSERVICE_APIS || false;
    if (this.ENABLE_ORDERBLOTTER_APIS) {
     this.orderBlotterUrl = '/irebal-order-blotter-service';
    }
  }

  checkIfBlockingJobInProgress() {
    // const rnd = (Math.random()*1e16).toString();
    // console.log('createOrderBlocks called');
    return this._http.get('/irebalone/block-action/is-blocking-job-in-progress', {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      }),
      'responseType': 'text'
    });
    //return of('NO_JOB_EXECUTION');
  }
  checkIfWarningOrdersExist(postData: any) {
    return this._http.post('/irebalone/blotter/check-if-warning-orders-exist', postData, this.httpOptions);
    //return of({"responseStatus":"SUCCESS","responseData":0,"responseUtilityMap":null});
  }
  stopBlockingJob() {
    return this._http.get('/irebalone/block-action/stop-blocking-job', {
      headers: new HttpHeaders({
        'Content-Type': 'text/plain',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      }),
      'responseType': 'text'
    });
  }
  getIdsTobeProcessed() {
    return this._http.get('/irebal/blotter/getIdsToBeProcessed?resolvedOnly=false', this.httpOptions);
  }
  checkAllBlockOrdersCount() {
    return this._http.get('/irebalone/block-action/check-all-block-orders-count', this.httpOptions);
    // return of({"responseStatus":"SUCCESS","responseData":0,"responseUtilityMap":null});
  }
  combineSelectedOrders(postData: any ) {
    return this._http.post( '/irebalone/block-action/combine-selected-orders', postData, this.httpOptions);
  }
  combineAsynSelectedCall( postData: any, filter: string) {
    if (filter) {
      filter = '?Filter=' + filter;
      postData = postData || {};
      postData.isFilterApplied = true;
    }
    return this._http.post( '/irebalone/block-action/combine-selected-order-asynch' + filter, postData, this.httpOptions);
      // console.log(postData, filter);
    // return of({"responseStatus":"SUCCESS","responseData":0,"responseUtilityMap":null});
  }
  combineAllOrders(postData:any) {
    return this._http.post( '/irebalone/block-action/combine-all-block-orders',postData, this.httpOptions);
  }
  combineAllBlockOrderAsynch(postData:any) {
    return this._http.post('/irebalone/block-action/combine-all-block-order-asynch',postData, this.httpOptions);
    // return of({"responseStatus":"SUCCESS","responseData":null,"responseUtilityMap":{"ordStatUpdId":911}});
  }
  getOrderStatusUpdate(idRef: string) {
    return this._http.get( '/irebalone/blotter-action/get-order-status-update/' + idRef, this.httpOptions);
      // console.log(idRef);
    // return of({"statusUpdateId":911,"requestedOperationName":"COMBINE_ALL_BLOCK",
    //   "envId":74825396,"requestedBy":"xxxkamin","requestedDate":1610655141709,
    //   "lastModifiedBy":null,"lastModifiedDate":null,"recievedCount":0,"successRecCount":0,
    //   "failedRecCount":0,"reqStatus":"STARTED","failMsg":null});
  }
  unblockSelectedOrders(postData: any) {
    return this._http.post('/irebalone/block-action/unblock-selected-orders', postData, this.httpOptions);
    // return of({"responseStatus":"SUCCESS","responseData":null,"responseUtilityMap":{"ordStatUpdId":911}});
  }
  unblockSelectedOrdersAsynch(postData: any) {
    return this._http.post('/irebalone/block-action/unblock-selected-orders-asynch', postData, this.httpOptions);
    // return of({"responseStatus":"SUCCESS","responseData":null,"responseUtilityMap":{"ordStatUpdId":911}});
  }

  getMasterAccount() {
    return this._http.get<any>('/irebalone/block-action/get-master-account');
  }

  getMasterAccountsAccess(): Observable<IMasterAccountAccessResponse> {
    return this._http.get<IMasterAccountAccessResponse>('/irebalone/blotter/check-master-access', this.httpOptions);
    // return of({
    //   "responseStatus": "SUCCESS",
    //   "responseData": {
    //       "isMasterAccountsAccessChanged": true,
    //       "lostMaster": [1000,2000,3000,4000,5000,6000,7000,8000,9000]
    //   },
    //   "responseUtilityMap": null
    // });
  }

  updateMasterAccessAsync(postData: any) {
    return this._http.post("/irebalone/blotter/update-master-access-async", postData, this.httpOptions);
    // return of({"rprasId": "1"});
  }

  checkMasterAccessStatus(_rprasId: string) {
    return this._http.get("/irebalone/blotter/check-master-access-status/" + _rprasId, this.httpOptions);
    // return of({"status": (Math.floor(Math.random() * 2)) ? "COMPLETED" : "INPROGRESS"});
  }

  updateOrderTradeVol(blockOrderIds: any) {
    return this._http.post('/irebalone/block-action/update-order-trade-vol', blockOrderIds);
    // false && console.log(blockOrderIds);
    // return of({
    //   "responseStatus": "SUCCESS",
    //   "responseData": [
    //     200241797,
    //     200241796
    //   ],
    //   "responseUtilityMap": null
    // })
  }

  defineResponse(res: any) {
    return res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
  }

  getAccountNumber(_s: string): Observable<Object> {
      const params = new HttpParams().set('s', _s);
      return this._http.get(this.orderBlotterUrl + '/order-entry/get-account-number', { params }).pipe(map(res => this.defineResponse(res)));
      //return of([{name: "123456789", value: "AC100"},{name: "120006789", value: "AC101"},{name: "123456000", value: "AC102"}]);
  }

  getAccountName(_s: string): Observable<Object> {
      const params = new HttpParams().set('s', _s);
      return this._http.get(this.orderBlotterUrl + '/order-entry/get-account-name', { params }).pipe(map(res => this.defineResponse(res)));
      //return of([{name: "AC100", value: "123456789"},{name: "AC101", value: "120006789"},{name: "AC102", value: "123456000"}]);
  }

  getSymbol(_s: string): Observable<Object> {
    const params = new HttpParams().set('s', _s);
    return this._http.get(this.orderBlotterUrl + '/order-entry/get-symbol', { params }).pipe(map(res => this.defineResponse(res)));
    //return of([{name: "ABC", value: "3456789"},{name: "CDE", value: "6789"},{name: "DEF", value: "1236000"}]);
  }

  getSymbolPrices(_s: string): Observable<Object> {
    const params = new HttpParams().set('symbol', _s);
    return this._http.get(this.orderBlotterUrl + '/order-entry/get-bid-and-ask-prices', { params }).pipe(map(res => this.defineResponse(res)));
    //return of([{name: "ABC", value: "3456789"},{name: "CDE", value: "6789"},{name: "DEF", value: "1236000"}]);
  }

  validateOrders(_tradeList: Array<IOrders>): Observable<Object> {
    return this._http.post(this.orderBlotterUrl + '/order-entry/async/validate-orders', _tradeList).pipe(map(res => this.defineResponse(res)));
  }

  validateOrdersStatus(_statusId: number): Observable<Object> {
    return this._http.get(this.orderBlotterUrl + '/order-entry/validate-orders-status/' + _statusId).pipe(map(res => this.defineResponse(res)));
  }

  insertOrders(_tradeList: Array<IOrders>): Observable<Object> {
    return this._http.post(this.orderBlotterUrl + '/order-entry/async/insert-orders', _tradeList).pipe(map(res => this.defineResponse(res)));
  }

  insertOrdersStatus(_statusId: number): Observable<Object> {
    return this._http.get(this.orderBlotterUrl + '/order-entry/insert-orders-status/' + _statusId).pipe(map(res => this.defineResponse(res)));
  }
}
